import React from 'react'
import udala from '../../assets/img/footer/Udala_Zabaltzen_logo.png'

function UdalaZabaltzenLogo({ className }) {
    return <img src={udala} className={className} alt="logo udala zabaltzen" />
}

export default UdalaZabaltzenLogo
